import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75df6434"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "googleReviews" }
const _hoisted_2 = { class: "google-pop" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "google-pop-content" }, "5,0", -1))
const _hoisted_5 = { class: "google-pop-stars google-pop-content" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "margin-block" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "section-title" }, "150 OPINIONES", -1))
const _hoisted_13 = { class: "opinion" }
const _hoisted_14 = { class: "google-pop-stars-content" }
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]
const _hoisted_18 = ["src"]
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "opinion-desciption" }
const _hoisted_21 = { class: "opinion-reviwer" }
const _hoisted_22 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "google-pop-content",
        src: require('@/assets/images/google-logo.png'),
        alt: "titulo_de_seccion"
      }, null, 8, _hoisted_3),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("img", {
          src: require('@/assets/images/reviews_star.png'),
          alt: "titulo_de_seccion"
        }, null, 8, _hoisted_6),
        _createElementVNode("img", {
          src: require('@/assets/images/reviews_star.png'),
          alt: "titulo_de_seccion"
        }, null, 8, _hoisted_7),
        _createElementVNode("img", {
          src: require('@/assets/images/reviews_star.png'),
          alt: "titulo_de_seccion"
        }, null, 8, _hoisted_8),
        _createElementVNode("img", {
          src: require('@/assets/images/reviews_star.png'),
          alt: "titulo_de_seccion"
        }, null, 8, _hoisted_9),
        _createElementVNode("img", {
          src: require('@/assets/images/reviews_star.png'),
          alt: "titulo_de_seccion"
        }, null, 8, _hoisted_10)
      ])
    ]),
    _hoisted_11,
    _hoisted_12,
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("img", {
          src: require('@/assets/images/reviews_star.png'),
          alt: "titulo_de_seccion"
        }, null, 8, _hoisted_15),
        _createElementVNode("img", {
          src: require('@/assets/images/reviews_star.png'),
          alt: "titulo_de_seccion"
        }, null, 8, _hoisted_16),
        _createElementVNode("img", {
          src: require('@/assets/images/reviews_star.png'),
          alt: "titulo_de_seccion"
        }, null, 8, _hoisted_17),
        _createElementVNode("img", {
          src: require('@/assets/images/reviews_star.png'),
          alt: "titulo_de_seccion"
        }, null, 8, _hoisted_18),
        _createElementVNode("img", {
          src: require('@/assets/images/reviews_star.png'),
          alt: "titulo_de_seccion"
        }, null, 8, _hoisted_19)
      ]),
      _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.GoogleReviews[_ctx.randomReviewNumber].description), 1),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("img", {
          src: require('@/assets/images/'+ _ctx.GoogleReviews[_ctx.randomReviewNumber].imagen ),
          alt: "titulo_de_seccion"
        }, null, 8, _hoisted_22),
        _createElementVNode("p", null, _toDisplayString(_ctx.GoogleReviews[_ctx.randomReviewNumber].puesto), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.GoogleReviews[_ctx.randomReviewNumber].name), 1)
      ])
    ])
  ]))
}